import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
// import Select from '@components/Select';
import {
  MenuItem, Select, FormControl, SelectChangeEvent,
} from '@mui/material';
import { changeUserStatus } from '@containers/Admin/containers/UserPage/actions';
import { SELECTOR_WIDTH, USER_STATUS_OPTIONS } from './consts';
import { UserStatus } from './types';

interface SelectStatusProps {
  isMentor: boolean;
}

/**
* Select for status
* @param {boolean} isMentor - Value for checking current user is mentor
* @returns {React.ReactElement} React element
*/
export const SelectStatus = ({ isMentor }: SelectStatusProps) => {
  const dispatch = useDispatch();
  const { userData: { id, state: status } } = useSelector((state: RootStateOrAny) => state.get('userPage').toJS()); // FIXME replace to typing store

  /**
  * Send status to backend by userID
  */
  const sendUserStatus = (event:SelectChangeEvent<UserStatus>): void => {
    dispatch(changeUserStatus(event.target.value, id));
  };

  const currentStatusHelper = ():UserStatus | undefined => USER_STATUS_OPTIONS.find(({ value }: UserStatus) => value === status);
  const currentStatusLabel = currentStatusHelper()?.label || '';
  if (isMentor) return <>{currentStatusLabel}</>;

  return (
    <div>
      {status && (
      <FormControl sx={{ width: SELECTOR_WIDTH }} size="small">
        <Select
          value={currentStatusHelper()}
          onChange={sendUserStatus}
          renderValue={() => currentStatusLabel}
        >
          {USER_STATUS_OPTIONS.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      )}
    </div>
  );
};
